import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useSeasonsLogic = () => {
  const apiRoute = "seasons";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "Name",
      label: "Season name",
      type: "text",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Season Name is required",
    },
    {
      name: "branch",
      label: "Branch",
      type: "dropdown",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Branch is required",
      returnID: true,
    },
    {
      name: "start_date",
      label: "Start date",
      countryCode: "branch.code",
      type: "datepicker",
      isRequired: true,
      err: "Start date is required",
      relatedWith: "end_date",
      allowTime: true,
    },
    {
      name: "end_date",
      label: "End date",
      countryCode: "branch.code",
      type: "datepicker",
      isRequired: true,
      err: "End date is required",
      minDate: "start_date",
      isClearable: true,
      allowTime: true,
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(
        config,
        "branches",
        "branch",
        temp,
        "Name",
        undefined,
        undefined,
        "code"
      ),
    ];
  };
  return {
    apiRoute,
    onlyForm,
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
  };
};

export default useSeasonsLogic;
